import chroma from 'chroma-js'
import Select from 'react-select'

interface GroupSelectProps {
  options: any[]
  value: string
  onChange: (option: any) => void
  isLoading: boolean
  isDisabled: boolean
}

const GroupSelect = ({ options, value, onChange, isLoading, isDisabled }: GroupSelectProps) => {
  const colorMark = (color = 'transparent') => ({
    alignItems: 'center',
    display: 'flex',
    ':before': {
      backgroundColor: color,
      content: '" "',
      display: 'block',
      marginRight: 8,
      height: 10,
      width: 10,
    },
  })

  const colourStyles = {
    control: (styles) => ({ ...styles, backgroundColor: 'white' }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      const color = chroma(data.color)
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? data.color
          : isFocused
          ? color.alpha(0.1).css()
          : undefined,
        color: isDisabled
          ? '#ccc'
          : isSelected
          ? chroma.contrast(color, 'white') > 2
            ? 'white'
            : 'black'
          : data.color,
        cursor: isDisabled ? 'not-allowed' : 'default',

        ':active': {
          ...styles[':active'],
          backgroundColor: !isDisabled
            ? isSelected
              ? data.color
              : color.alpha(0.3).css()
            : undefined,
        },
      }
    },
    input: (styles) => ({ ...styles, ...colorMark() }),
    placeholder: (styles) => ({ ...styles, ...colorMark('#ccc') }),
    singleValue: (styles, { data }) => ({ ...styles, ...colorMark(data.color) }),
  }

  return (
    <Select
      instanceId='category-select'
      options={options}
      value={options.find((it) => it.value === value)}
      onChange={onChange}
      isLoading={isLoading}
      isDisabled={isDisabled}
      styles={colourStyles}
    />
  )
}

export default GroupSelect
